import { Edition } from '@atlassian/touchpoint-commons-event-analytics/types';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'changePlan',
	dialogId: 'collection-change-plan-popup',
	dialogType: 'pop-up',
	targetProductEdition: Edition.SELECTION,
};
